// besturimz-website/src/components/Footer.js
import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaSyncAlt } from 'react-icons/fa'
import { PHONE_NUMBERS, CONTACT_EMAIL } from '../constants/contact'

const PARTNERS = [
  { name: 'Turkish Airlines', file: 'thy.png' },
  { name: 'Pegasus', file: 'pegasus.png' },
  { name: 'SunExpress', file: 'sunexpress.png' },
  { name: 'Ajet', file: 'Ajet.png' },
  { name: 'Qatar Airways', file: 'qatar.png' },
]

const FooterContainer = styled.footer`
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%) !important;
  padding: 1rem 0 1rem 0 !important;
  margin-top: 2rem;
  scroll-margin-top: 80px;
`

const Container = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
`

// İş Ortakları Bölümü
const PartnersSection = styled.div`
  text-align: center;
  margin-bottom: 1rem;
  padding: 1rem 16px 1.25rem;
`

const PartnersLogos = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: center;
  gap: clamp(4px, 0.8vw, 12px);
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
`

const PartnerLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  height: clamp(28px, 4vw, 40px);
  overflow: visible;
`

const PartnerLogoImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  transition: transform 0.25s ease;
  transform-origin: center center;

  @media (hover: hover) {
    ${PartnerLogo}:hover & {
      transform: scale(1.15);
    }
  }
`

// Ana İçerik Bölümü - Tam genişlik
const MainContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; /* Sol ve sağ sütunlar eşit genişlikte */
  gap: 0;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

// Sol Taraf - İletişim Formu
const ContactFormSection = styled.div`
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%); /* Koyu gri gradient */
  padding: 1rem 1.2rem;
  border-radius: 0;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.3);
  border-right: 1px solid #4b5563;

  @media (max-width: 768px) {
    border-right: none;
    border-bottom: 1px solid #4b5563;
  }
`

const FormTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
  color: #f3f4f6; /* Açık gri başlık */
  margin-bottom: 0.6rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
`

const FormGrid = styled.div`
  display: flex;
  gap: 2rem; /* Gap daha da artırıldı */
  margin-bottom: 0.6rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1; /* Eşit genişlik */
  padding: 0 0.5rem; /* Padding artırıldı */
`

const Label = styled.label`
  font-size: 0.8rem;
  font-weight: 500;
  color: #d1d5db; /* Açık gri label */
  margin-bottom: 0.3rem;
  text-align: left; /* Sola hizala */
`

const Input = styled.input`
  padding: 8px 12px;
  border: 2px solid #4b5563; /* Koyu gri border */
  border-radius: 6px;
  font-size: 0.8rem;
  background: #1f2937; /* Koyu arka plan */
  color: #f3f4f6; /* Açık gri metin */
  transition: all 0.3s ease;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #6b7280; /* Açık gri focus */
    background: #374151; /* Daha açık arka plan */
    box-shadow: 0 0 0 3px rgba(107, 114, 128, 0.1);
    transform: translateY(-1px);
  }

  &::placeholder {
    color: #9ca3af; /* Placeholder rengi */
  }
`

const TextArea = styled.textarea`
  padding: 8px 12px;
  border: 2px solid #4b5563; /* Koyu gri border */
  border-radius: 6px;
  font-size: 0.8rem;
  background: #1f2937; /* Koyu arka plan */
  color: #f3f4f6; /* Açık gri metin */
  resize: both;
  min-height: 120px;
  width: 100%;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #6b7280; /* Açık gri focus */
    background: #374151; /* Daha açık arka plan */
    box-shadow: 0 0 0 3px rgba(107, 114, 128, 0.1);
    transform: translateY(-1px);
  }

  &::placeholder {
    color: #9ca3af; /* Placeholder rengi */
  }

  @media (max-width: 768px) {
    resize: vertical;
  }
`

const CaptchaSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between; /* Captcha ve buton arasında boşluk */
  gap: 0.4rem;
  margin-bottom: 0.5rem;
`

const CaptchaBox = styled.div`
  min-width: 52px;
  height: 25px;
  padding: 0 6px;
  background: #1f2937;
  border: 1px solid #4b5563;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f3f4f6;
  font-weight: bold;
  font-size: 0.8rem;
  letter-spacing: 0.08em;
`

const CaptchaRefreshButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border: 1px solid #4b5563;
  border-radius: 4px;
  background: #374151;
  color: #e5e7eb;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;

  &:hover {
    background: #4b5563;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const CaptchaInput = styled(Input)`
  width: 60px;
  margin-right: 0.5rem;
`

const SubmitButton = styled.button`
  background: #1e3a8a;
  color: #fff;
  padding: 4px 8px;
  border: none;
  border-radius: 3px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-left: auto;

  &:hover:not(:disabled) {
    background: #1a365d;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const StatusMessage = styled.p`
  font-size: 0.75rem;
  margin: 0.4rem 0 0;
  color: ${props => (props.$success ? '#86efac' : '#fca5a5')};
`

// Sağ Taraf - Adres ve Bilgi
const AddressSection = styled.div`
  background: linear-gradient(135deg, #1f2937 0%, #374151 100%); /* Koyu gri gradient */
  padding: 1rem;
  border-radius: 0;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const AddressTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 700;
  color: #f3f4f6; /* Açık gri başlık */
  margin-bottom: 0.6rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
`

const InfoText = styled.p`
  font-size: 0.8rem;
  line-height: 1.4;
  color: #d1d5db; /* Açık gri metin */
  margin-bottom: 0.8rem;
`

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 0.8rem; /* Margin azaltıldı */
`

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #d1d5db; /* Açık gri metin */
`

const ContactIcon = styled.div`
  color: #6b7280; /* Açık gri ikon */
  font-size: 0.9rem;
  width: 14px;
  flex-shrink: 0;
`

const ContactText = styled.span`
  font-size: 0.8rem;
  line-height: 1.3;
`

const MapLink = styled.a`
  color: #9ca3af; /* Açık gri link */
  text-decoration: none;
  font-weight: 500;

  &:hover {
    color: #d1d5db; /* Hover'da daha açık */
    text-decoration: underline;
  }
`

// Copyright bölümü - Koyu tema
const CopyrightSection = styled.div`
  border-top: 1px solid #4b5563; /* Koyu gri border */
  padding: 0.5rem 0;
  text-align: center;
  color: #9ca3af; /* Açık gri metin */
  font-size: 0.65rem;
  line-height: 1.1;
  margin-top: auto; /* En alta it */
`

const Footer = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    captcha: '',
  })
  const [captchaCode, setCaptchaCode] = useState('')
  const [captchaToken, setCaptchaToken] = useState('')
  const [captchaLoading, setCaptchaLoading] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null)

  const loadCaptcha = useCallback(async () => {
    setCaptchaLoading(true)
    try {
      const response = await fetch('/.netlify/functions/get-captcha', {
        cache: 'no-store',
      })
      if (!response.ok) throw new Error('captcha failed')
      const data = await response.json()
      setCaptchaCode(data.code || '')
      setCaptchaToken(data.token || '')
      setFormData((prev) => ({ ...prev, captcha: '' }))
    } catch {
      setCaptchaCode('')
      setCaptchaToken('')
      setSubmitStatus({
        success: false,
        message: 'Güvenlik kodu yüklenemedi. npm run dev ile tekrar deneyin.',
      })
    } finally {
      setCaptchaLoading(false)
    }
  }, [])

  useEffect(() => {
    loadCaptcha()
  }, [loadCaptcha])

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
    if (submitStatus) setSubmitStatus(null)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!captchaToken || !formData.captcha.trim()) {
      setSubmitStatus({ success: false, message: 'Lütfen güvenlik kodunu girin.' })
      return
    }

    setIsSubmitting(true)
    setSubmitStatus(null)

    try {
      const response = await fetch('/.netlify/functions/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          captcha: formData.captcha,
          captchaToken,
        }),
      })

      let data
      try {
        data = await response.json()
      } catch {
        setSubmitStatus({
          success: false,
          message: 'Sunucu yanıtı okunamadı. npm run dev ile test edin (port 3000).',
        })
        return
      }

      if (response.ok) {
        setSubmitStatus({ success: true, message: data.message })
        setFormData({ name: '', email: '', subject: '', message: '', captcha: '' })
        loadCaptcha()
      } else {
        setSubmitStatus({
          success: false,
          message: data.error || 'Mesaj gönderilemedi. Lütfen tekrar deneyin.',
        })
        loadCaptcha()
      }
    } catch {
      setSubmitStatus({
        success: false,
        message: 'Bağlantı hatası. Lütfen tekrar deneyin.',
      })
      loadCaptcha()
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <FooterContainer id="footer">
      <Container>
        {/* İş Ortakları */}
        <PartnersSection>
          <PartnersLogos>
            {PARTNERS.map((partner) => (
              <PartnerLogo key={partner.file}>
                <PartnerLogoImage
                  src={`${process.env.PUBLIC_URL}/ortaklar/${partner.file}`}
                  alt={partner.name}
                  loading="lazy"
                />
              </PartnerLogo>
            ))}
          </PartnersLogos>
        </PartnersSection>

        {/* Ana İçerik - Tam genişlik */}
        <MainContent>
          {/* Sol Taraf - İletişim Formu */}
          <ContactFormSection>
            <FormTitle>Bize Mesaj Gönderin...</FormTitle>
            <form onSubmit={handleSubmit}>
            <FormGrid>
                <FormGroup>
                    <Label>AD SOYAD:</Label>
                    <Input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                    />
                </FormGroup>
                
                <FormGroup>
                    <Label>E-POSTA ADRESI:</Label>
                    <Input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                </FormGroup>
                
                <FormGroup>
                    <Label>KONU:</Label>
                    <Input
                        type="text"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                    />
                </FormGroup>
            </FormGrid>
            
            <FormGroup style={{ marginBottom: '0.6rem' }}>
                <Label>ILETINIZ:</Label>
                <TextArea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                />
            </FormGroup>
            <CaptchaSection>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                <CaptchaBox>{captchaLoading ? '...' : captchaCode || '----'}</CaptchaBox>
                <CaptchaRefreshButton
                  type="button"
                  onClick={loadCaptcha}
                  disabled={captchaLoading || isSubmitting}
                  aria-label="Güvenlik kodunu yenile"
                  title="Kodu yenile"
                >
                  <FaSyncAlt size={11} />
                </CaptchaRefreshButton>
                <CaptchaInput
                    type="text"
                    name="captcha"
                    value={formData.captcha}
                    onChange={handleInputChange}
                    placeholder="Kodu girin"
                    inputMode="numeric"
                    autoComplete="off"
                    required
                />
                </div>
                <SubmitButton type="submit" disabled={isSubmitting || captchaLoading || !captchaToken}>
                  {isSubmitting ? 'Gönderiliyor...' : 'Formu Gönder'}
                </SubmitButton>
            </CaptchaSection>
            {submitStatus && (
              <StatusMessage $success={submitStatus.success}>
                {submitStatus.message}
              </StatusMessage>
            )}
            </form>
          </ContactFormSection>
          
          {/* Sağ Taraf - Adres ve Bilgi */}
          <AddressSection>
            <AddressTitle>İletişim Bilgileri</AddressTitle>
            
            <InfoText>
              BESTURİZM olarak, sağlıklı ve kaliteli hizmet sunmak için buradayız. 
              Sorularınız ve önerileriniz için bizimle 7/24 iletişime geçebilirsiniz.
            </InfoText>

            <ContactInfo>
              <ContactItem>
                <ContactIcon>
                  <FaMapMarkerAlt />
                </ContactIcon>
                <ContactText>
                  <MapLink href="https://maps.app.goo.gl/bZY3q1H179yx8h8n6" target="_blank" rel="noopener noreferrer">
                    Akdeniz Mahallesi GMK Blv. Erdoğan Center No:910/20 Kat:7<br />
                    Mezitli / Mersin
                  </MapLink>
                </ContactText>
              </ContactItem>

              <ContactItem>
                <ContactIcon>
                  <FaPhone />
                </ContactIcon>
                <ContactText>
                  {PHONE_NUMBERS.map((phone, index) => (
                    <span key={phone.tel}>
                      {index > 0 && <br />}
                      <a href={`tel:${phone.tel}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                        {phone.display}
                      </a>
                    </span>
                  ))}
                </ContactText>
              </ContactItem>

              <ContactItem>
                <ContactIcon>
                  <FaEnvelope />
                </ContactIcon>
                <ContactText>
                  <a href={`mailto:${CONTACT_EMAIL}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                    {CONTACT_EMAIL}
                  </a>
                </ContactText>
              </ContactItem>

              <ContactItem>
                <ContactIcon>
                  <FaClock />
                </ContactIcon>
                <ContactText>Pazartesi - Cumartesi: 09:00 - 18:00</ContactText>
                <ContactText>7/24 Aktif Hizmet Sağlıyoruz</ContactText>
              </ContactItem>
            </ContactInfo>
            
            {/* Copyright sağ bölümün içinde */}
            <CopyrightSection>
              <p>&copy; 2024 BESTURİZM. Tüm hakları saklıdır.</p>
            </CopyrightSection>
          </AddressSection>
        </MainContent>
      </Container>
    </FooterContainer>
  )
}

export default Footer